import { type FC, type Ref } from 'react';

/* eslint-disable-next-line no-restricted-imports */
import RootCheckbox, { type CheckboxProps as RootCheckboxProps } from '@mui/material/Checkbox';

import * as types from './types';

export interface CheckboxProps extends Omit<
  RootCheckboxProps,
  | 'checked'
  | 'disabled'
  | 'disableFocusRipple'
  | 'disableRipple'
  | 'disableTouchRipple'
  | 'indeterminate'
  | 'ref'
> {
  readonly isDisabled?: boolean;
  readonly isIndeterminate?: boolean;
  readonly isSelected?: boolean;
  readonly ref?: Ref<HTMLInputElement>;
  readonly state?: types.CheckboxState;
  /* eslint-disable-next-line react/boolean-prop-naming */
  readonly value?: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({
  isDisabled,
  isIndeterminate,
  isSelected,
  ref,
  state,
  value,
  ...props
}) => (
  <RootCheckbox
    size='small'
    {...props}
    checked={value ?? isSelected ?? state === types.CheckboxState.Selected}
    disabled={isDisabled}
    disableFocusRipple
    disableRipple
    disableTouchRipple
    indeterminate={isIndeterminate ?? state === types.CheckboxState.Indeterminate}
    inputRef={ref}
  />
);
